import { Component, OnInit } from '@angular/core';
import { SettingsService } from './services/settings.service';
import { TidioChatService } from './services/tidio-chat.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
  title = 'vendor-menu';

  constructor(
    private settingsService:SettingsService,
    private tidioChatService:TidioChatService
  ) {}

  public ngOnInit():void {
    this.settingsService.loadSettingsFromCookies();
    this.loadChat();
  }

  public loadChat(){
    this.tidioChatService.init();
  }
}
